import React, { useState, useContext, useEffect } from "react";
import "./MembershipBooking.css";
import { StateContext } from "../../../../StateProvider";
import NeedHelp from "../../../../Utilities/components/NeedHelp";
import Footer from "../../../../Footer";

function MembershipBooking() {
  var context = useContext(StateContext);
  var setBookingData = context.setBookingData;
  var serviceDetails = context.serviceDetails || {};
  var today = new Date();

  var [membershipBookingData, setMembershipBookingData] = useState({
    selectedPackage: "",
    dateRange: [today]
  });

  /* --------------------------------------------------
     🔍 Find membership prices dynamically
  -------------------------------------------------- */
  function findMembershipPrice(keyword) {
    if (!serviceDetails) return null;

    var keys = Object.keys(serviceDetails);
    var i, j;

    for (i = 0; i < keys.length; i++) {
      var list = serviceDetails[keys[i]];
      if (!list || !list.length) continue;

      for (j = 0; j < list.length; j++) {
        var item = list[j];
        if (!item || !item.serviceName) continue;

        var name = String(item.serviceName).toLowerCase();
        var target = String(keyword).toLowerCase();

        if (name.indexOf(target) !== -1) {
          return Number(item.price);
        }
      }
    }
    return null;
  }

  var clubPrice = findMembershipPrice("pawsible club");
  var plusPrice = findMembershipPrice("pawsible plus");

  // Fallback values if admin hasn't set values
  var priceClub = clubPrice != null ? clubPrice : 99;
  var pricePlus = plusPrice != null ? plusPrice : 149;

  /* --------------------------------------------------
     Update global bookingData when membership changes
  -------------------------------------------------- */
  useEffect(
    function () {
      setBookingData(function (prev) {
        var updated = {};
        for (var k in prev) updated[k] = prev[k];

        updated.bookingType = "store/membership";
        updated.bookingInfo = membershipBookingData;
        return updated;
      });
    },
    [membershipBookingData]
  );

  /* --------------------------------------------------
     Handle membership selection
  -------------------------------------------------- */
  function handlePackageSelect(key) {
    setMembershipBookingData(function (prev) {
      var updated = {};
      var same = prev.selectedPackage === key;

      for (var k in prev) updated[k] = prev[k];

      updated.selectedPackage = same ? "" : key;
      return updated;
    });
  }

  var selected = membershipBookingData.selectedPackage;

  /* --------------------------------------------------
     Membership Plans (Dynamic Pricing)
  -------------------------------------------------- */
  var plans = [
    {
      key: "Club",
      label: "Pawsible Club",
      color: "#4CA7DF",
      price: priceClub,
      benefits: {
        discount: "10%",
        concierge: "✓",
        feeding: "✓",
        health: "✓",
        report: "✓",
        events: "✓",
        booking: "—",
        birthday: "—",
        bonus: "—",
        free_ride: "—"
      }
    },
    {
      key: "Plus",
      label: "Pawsible Plus Club",
      color: "#FFB516",
      price: pricePlus,
      benefits: {
        discount: "20%",
        concierge: "✓",
        feeding: "✓",
        health: "✓",
        report: "✓",
        events: "✓",
        booking: "✓",
        birthday: "✓",
        bonus: "✓",
        free_ride: "✓"
      }
    }
  ];

  /* --------------------------------------------------
     Benefit Labels
  -------------------------------------------------- */
  var benefitLabels = [
    { id: "discount", text: "Member Savings" },
    { id: "concierge", text: "Concierge & Text Support" },
    { id: "feeding", text: "Premium Daily Feeding" },
    { id: "health", text: "Health & Grooming Check" },
    { id: "report", text: "Daycare Report Card" },
    { id: "events", text: "Exclusive Member Events" },
    { id: "booking", text: "Top-Priority Booking" },
    { id: "birthday", text: "Birthday Gift" },
    { id: "bonus", text: "Nail Trim & Teeth Brushing" },
    { id: "free_ride", text: "Free Daycare Shuttle This Month" }
  ];

  /* --------------------------------------------------
     Component Return
  -------------------------------------------------- */
  return (
    <div>
      <div className="membership-container">
        <div className="membership-header">
          <h2>Membership</h2>
          <p>Choose what fits your pet’s lifestyle best.</p>
        </div>

        <div className="membership-chart">
          {/* Header */}
          <div className="chart-header">
            <span className="benefit-label"></span>

            {(function () {
              var cols = [];
              var i;
              for (i = 0; i < plans.length; i++) {
                (function (plan) {
                  var isSelected = selected === plan.key;
                  var className = isSelected
                    ? "chart-col selected"
                    : "chart-col";

                  cols.push(
                    <div
                      key={plan.key}
                      className={className}
                      onClick={function () {
                        handlePackageSelect(plan.key);
                      }}
                    >
                      <h3 style={{ color: plan.color }}>{plan.label}</h3>
                      <div className="chart-price">
                        ${plan.price} / mo
                      </div>
                    </div>
                  );
                })(plans[i]);
              }
              return cols;
            })()}
          </div>

          {/* Benefits Matrix */}
          <ul className="benefit-matrix">
            {(function () {
              var rows = [];
              var i;

              for (i = 0; i < benefitLabels.length; i++) {
                (function (row) {
                  var benefitRow = [];

                  benefitRow.push(
                    <span key={"label-" + row.id} className="benefit-text">
                      {row.text}
                    </span>
                  );

                  var j;
                  for (j = 0; j < plans.length; j++) {
                    var plan = plans[j];
                    var val = plan.benefits[row.id];
                    var show = val === "✓" ? "✓" : val || "—";
                    var cls = "benefit-val ";

                    if (row.id === "discount") {
                      cls += val === "20%" ? "discount-high" : "discount-low";
                    } else {
                      cls += plan.key === "Club" ? "tier-club" : "tier-plus";
                    }

                    benefitRow.push(
                      <span key={plan.key + "-" + row.id} className={cls}>
                        {show}
                      </span>
                    );
                  }

                  rows.push(
                    <li
                        key={row.id}
                        className={
                          row.id === "free_ride"
                            ? "benefit-row benefit-row-highlight"
                            : "benefit-row"
                        }
                      >
                      {benefitRow}
                    </li>
                  );
                })(benefitLabels[i]);
              }

              return rows;
            })()}
          </ul>
        </div>
      </div>

      <div className="sign-up-section">
        <NeedHelp />
      </div>

      <Footer />
    </div>
  );
}

export default MembershipBooking;
